import { Typography } from '@mui/material'
import { styled } from '@mui/styles'

export default styled(Typography)(({ theme }) => ({
  marginTop: '20px',
  color: theme.palette.customGrey[700],
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '20px'
}))
